import { render, staticRenderFns } from "./PlaneBuffer.vue?vue&type=template&id=cee83a6c&"
import script from "./PlaneBuffer.vue?vue&type=script&lang=js&"
export * from "./PlaneBuffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports